import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { HttpUtilityService } from "src/app/http/http-utility.service";
import { yccApiUrl} from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
    public httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
  constructor(private http: HttpClient,
  private _httpService: HttpUtilityService) {}
  private extractData(res: Response) {
    const body = res;
    return body || { };
  }
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  newRegistration (request): Observable<any> {
    console.log(request);
  let uri = 'registration/newRequest'  ;
  return this._httpService.post(uri, request);
}

updateRegistrationStatus (request): Observable<any> {
  console.log(request);
let uri = 'registration/updateStatus'  ;
return this._httpService.post(uri, request);
}
 public getallRequest(): Observable<any> {
    let uri = 'registration/getallRequest';
    return this._httpService.get(uri);
  }

  public getRegistrationDetails(organizationguid): Observable<any> {
    let uri = 'registration/GetOrganization/' + organizationguid;
    return this._httpService.get(uri);
  }

  public getOrganizationFileUrls(organizationguid): Observable<any> {
    let uri = 'registration/getOrganizationFileUrls/' + organizationguid;
    return this._httpService.get(uri);
  }

  public getOrganizationNotes(organizationguid): Observable<any> {
    let uri = 'registration/getNotes/' + organizationguid;
    return this._httpService.get(uri);
  }

  newRegistration1 (request): Observable<any> {
    console.log(request);
    return this.http.post<any>(yccApiUrl + 'registration/newRequest', JSON.stringify(request), this.httpOptions).pipe(
      tap((result) => console.log(result)),
      catchError(this.handleError<any>('addProduct'))
    );
  }
}
